<template>
  <div>
    <signature-layout
      :submitSignature="sign"
      :signatureId="signatureId"
      :isLoading="isLoading"
      :foundRequest="found"
      :errorMessage="errorMessage"
      :workflowGuid="registration.workflowGuid"
      :submittedAt="registration.submittedAt"
    >
      <span slot="subtitle"> Registration Application </span>
      <span slot="title">Lease Agreement</span>
      <div slot="approvedContent" v-if="registration && registration.requestId">
        <div class="mt-5">
          <v-dialog class="w-50" v-model="rulesDialog">
            <v-card class="search-modal text-left">
              <h2>Rules</h2>
              <p>
                This form is solely for the purpose of determining who may sign
                ASCA registry forms on this dog, during the specific period.
                This form must be completed and filed with the ASCA Business
                Office before any litters will be registered.
              </p>
              <p>All Lessee Memberships must be current.</p>
              <p>
                ANYONE WISHING TO BE LITTER OWNERS DURING LEASE PERIOD MUST BE
                LISTED AS LESSEES, INCLUDING OWNERS OF DAM.
              </p>
            </v-card>
          </v-dialog>
          <a v-on:click="toggleRules()">View rules</a>
          <lease-request :registration="registration"> </lease-request>
        </div>
      </div>
      <div slot="legalText">
        <p class="bottom-text">
          Upon signing, I testify that all data submitted is correct. I
          understand that all applications become the property of ASCA. If an
          application has been falsified, the lease will be revoked and fees
          will not be refunded. I further understand that as an owner of an ASCA
          registered dog, I agree to abide by the <ASCAArtIncLink />,
          <BylawsLink />, and rules of the ASCA Registry, Conformation,
          Obedience and Stock Dog Program and to disciplinary action, if
          necessary, as determined by the ASCA Board of Directors.
        </p>
      </div>
    </signature-layout>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import SignatureLayout from "@/components/common/SignatureLayout.vue";
import LeaseRequest from "@/components/Portal/MyRequest/LeaseRequest.vue";
import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
import BylawsLink from "@/components/common/BylawsLink.vue";

import { UserInfo } from "@/types/User";
import workflowService from "@/services/portal/workflowService";
import { getErrorMessage } from "@/services/errorHandler";

export default Vue.extend({
  name: "LeaseSignatureForm",
  components: {
    SignatureLayout,
    LeaseRequest,
    ASCAArtIncLink,
    BylawsLink,
  },
  props: { signatureId: Number },
  data: function () {
    return {
      signatureText: "",
      errorMessage: "",
      registration: Object,
      isLoading: false,
      found: false,
      rulesDialog: false,
    };
  },
  created() {
    this.load();
  },
  watch: {
    signatureId: function (newValue) { this.load(); }
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    toggleRules() { this.$data.rulesDialog = !this.$data.rulesDialog; },
    load: async function () {
      this.isLoading = true;
      this.errorMessage = "";
      this.found = false;

      try {
        const response = await workflowService.getLeaseDetailsForSignature(this.signatureId);
        this.found = response.found;

        if (response.found && (!response.errors || response.errors.length == 0)) {
          this.registration = response.data;
        } else if (!!response.errors) this.errorMessage = response.errors ? response.errors.join(',') : 'An Unknown Error Occured'
      } catch (error) {
        this.errorMessage = getErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    sign: function (workflowGuid: String, signatureId: number, text: String) {
      workflowService
        .signLease(workflowGuid, signatureId, text)
        .then((res) => {
          this.$store.dispatch("loadPersonTasks");
          this.$navigate("/");
        }).catch(this.$handleError);
    },
  },
});
</script>
